<template>
  <section
    v-if="wasIdle && !signedIn"
    class="hero is-fullheight is-medium is-bold"
  >
    <div class="hero-body">
      <div class="container custom-container">
        <div class="columns is-centered">
          <div class="column is-4 is-mobile">
            <div class="box">
              <div class="columns">
                <div class="column header-logo has-text-centered">
                  <img
                    src="/aceas/assets/common/vendor/xbase/img/cea-logo.png"
                    alt="aceas logo"
                  />
                </div>
              </div>
              <template v-if="wasIdle">
                <div class="content">
                  <h1 class="has-text-centered">
                    You're about to be signed out of ACEAS
                  </h1>
                  <p class="has-text-centered">
                    Your session has expired due to a period of inactivity.
                    <br />Please sign out this account and sign in again if you
                    wish to continue.
                  </p>
                </div>
                <button
                  class="xb-button button is-secondary is-fullwidth"
                  @click.prevent="signOut"
                >
                  SIGN OUT
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// app module import
import Mgr from "../../services/securityService";

// Utility functions
const mapState = window.Vuex.mapState;

export default {
  name: "Login",
  data() {
    return {
      mgr: new Mgr(this.$store.state.config.configurationData.common_module)
    };
  },

  computed: {
    ...mapState({
      wasIdle: state => state.auth.wasIdle,
      signedIn: state => state.auth.signedIn
    })
  },

  mounted() {
    if (!this.wasIdle && !this.signedIn) {
      this.signIn();
    }
  },

  methods: {
    signIn() {
      this.$store.dispatch("setApplicationLoadingToTrue");

      this.$store.commit("auth/setIsManuallySignedOut", false);
      this.mgr.getSignedIn(
        this.$route.query.destination,
        this.$route.query.kc_idp_hint
      );
    },

    signOut() {
      this.$emit("logout", true);

      this.$store.commit("auth/setIsManuallySignedOut", true);
      this.mgr.signOut();
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-container {
  width: 100%;
}

.column.header-logo img {
  max-height: 120px;
}

.box {
  border-bottom: 10px solid #145fac;
}

.xb-stroked-text {
  position: relative;
  background-color: white;
  text-align: center;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;

  &:before {
    content: "";
    height: 1px;
    flex: 1 1 auto;
    background-color: lightgray;
    margin-right: 20px;
  }

  &:after {
    content: "";
    height: 1px;
    flex: 1 1 auto;
    margin-left: 20px;
    background-color: lightgray;
  }
}
</style>
